import { render, staticRenderFns } from "./ReadView.vue?vue&type=template&id=161280d4&scoped=true&"
import script from "./ReadView.vue?vue&type=script&lang=js&"
export * from "./ReadView.vue?vue&type=script&lang=js&"
import style0 from "./ReadView.vue?vue&type=style&index=0&id=161280d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161280d4",
  null
  
)

/* custom blocks */
import block0 from "./ReadView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports